// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseTable_container_3DEJA","spinAround":"BaseTable_spinAround_2XC1i"};